import { Box, Typography } from '@mui/material';
import { SxProps } from '@mui/system';
import { useMemo } from 'react';
import { useAppSelector } from '../../app/hooks';
import {
  ChartDropdownDimensionEnum,
  selectCurrChartDimension,
} from '../../services/data/impl/cube/cubeSlice';
import { isBlueberryFeature } from '../../services/data/impl/cube/cubeUtils';
import { flexCenter } from '../commonUI/cssClasses';
import { selectCurrFeature } from '../select/selectSlice';
import BlueberryClassDistribution from './BlueberryClassDistribution';
import BlueberryDistributionChart from './BlueberryDistributionChart';
import BlueberryEstimatedCountRowsideStackBarChart from './BlueberryEstimatedCountRowsideStackBarChart';
import ColorDistributionChart from './ColorDistributionChart';
import DistributionChart from './DistributionChart';
import EstimatedCountRowsideStackBarChart from './EstimatedCountRowsideStackBarChart';
// import { InteractionItem } from 'chart.js';

const commonStyles: SxProps = {
  width: '100%',
  height: '100%',
  ...flexCenter,
};

interface Props {
  chartType: string;
  plugins?: object;
}

const RenderChart: React.FC<Props> = ({ chartType, plugins }) => {
  const currChartDimension = useAppSelector(selectCurrChartDimension);
  const currFeature = useAppSelector(selectCurrFeature);

  const chart = useMemo(() => {
    if (currChartDimension === ChartDropdownDimensionEnum.perRowside) {
      if (!isBlueberryFeature(currFeature)) {
        return <EstimatedCountRowsideStackBarChart plugins={plugins} />;
      }
      return <BlueberryEstimatedCountRowsideStackBarChart plugins={plugins} />;
    }

    if (currChartDimension === ChartDropdownDimensionEnum.distribution) {
      if (!isBlueberryFeature(currFeature)) {
        return <DistributionChart plugins={plugins} />;
      }
      return <BlueberryClassDistribution plugins={plugins} />;
    }
    if (currChartDimension === ChartDropdownDimensionEnum.colorDistribution) {
      if (!isBlueberryFeature(currFeature)) {
        return <ColorDistributionChart plugins={plugins} />;
      }

      return <BlueberryDistributionChart plugins={plugins} />;
    }
    return null;
  }, [currChartDimension, currFeature, plugins]);

  if (!chart) {
    return (
      <Box sx={{ ...commonStyles }}>
        <Typography>
          Data for that scan or query is not currently available.
        </Typography>
      </Box>
    );
  }
  return <>{chartType === 'bar' && chart}</>;
};

export default RenderChart;
